import langs from '@/utils/langs'
 
export default  {
  'zh.langs':langs.getLangs(require.context('./', true, /^\.\/modules\/([\s\S])+\.js$/)),
}


// WEBPACK FOOTER //
// ./src/i18n/locales/zh-cn/zh.langs.js